import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

function NoAuthProvider({ children }) {
    const uid = useSelector((state) => state.identityReducer.identity ? state.identityReducer.identity.uid : null)

    return uid ? <Navigate to="/" /> : <>{ children }</>
}

export default NoAuthProvider